import { render, staticRenderFns } from "./senior.vue?vue&type=template&id=64b47e29&scoped=true&"
import script from "./senior.vue?vue&type=script&lang=js&"
export * from "./senior.vue?vue&type=script&lang=js&"
import style0 from "./senior.vue?vue&type=style&index=0&lang=less&"
import style1 from "./senior.vue?vue&type=style&index=1&id=64b47e29&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b47e29",
  null
  
)

export default component.exports